import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import BeddingSection from './sections/BeddingSection';
import BedSection from './sections/BedSection';
import TowelRobesSection from './sections/TowelRobesSection';
import SeoCopySection from './sections/SeoCopySection';
import MobileBeddingLinensSection from './sections/MobileBeddingLinensSection';

const Home = () => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection />
      <BeddingSection />
      <BedSection />
      <TowelRobesSection />
      <MobileBeddingLinensSection />
      <SeoCopySection />
    </div>
  );
};

export default Home;
